import './list/teleconsent.manager.list.new';

angular.module('doxy.realtime.components.teleconsent.manager', [
  'doxy.realtime.components.teleconsent.manager.list.new',
]);
